// SEARCH FILTER TYPES
export const APPLY_FILTERS = 'onboardingList/applySearchFilter'
export const HIDE_LIST_ALERT = 'onboardingList/hideAlert'
export const SET_LIST_ALERT = 'onboardingList/setAlertModal'
export const IS_LOADING = 'onboardingList/isLoading'
export const SET_CONFIRM_MODAL = 'onboardingList/setConfirmModal'
export const HIDE_CONFIRM_MODAL = 'onboardingList/hideConfirmModal'
export const SHOW_CONFIRM_MODAL = 'onboardingList/showConfirmModal'
export const RESET_FILTERS = 'onboardingList/reset'
export const RESET_RESULTS = 'onboardingList/resetTableData'
export const UPDATE_SEARCHLIST = 'onboardingList/updateResults'
export const CHG_FILTER_DATA = 'onboardingList/changeFilterField'
export const CHG_FILTER_PAGE = 'onboardingList/changePage'
export const CHG_FILTER_PAGE_SIZE = 'onboardingList/changePageSize'
export const CHG_FILTER_SORT = 'onboardingList/changeSortModel'
export const CHG_SELECTED_ROWS = 'onboardingList/changeSelected'
export const SHOW_EXPORT_MODAL = 'onboardingList/showExportModal'

// ADD FORM TYPES
export const RESET_ADD_DATA = 'onboardingAdd/reset'
export const UPD_ADD_ALERT = 'onboardingAdd/updateAlert'
export const INSERT_LOADING = 'onboardingAdd/isLoading'
export const CHG_FIELD = 'onboardingAdd/changeField'
export const CHG_STATUS = 'onboardingAdd/changeStatus'
export const SET_ADD_DATA = 'onboardingAdd/setAddData'
export const HIDE_ADD_ALERT = 'onboardingAdd/hideAlert'
export const HIDE_MODAL = 'onboardingAdd/hideModal'
export const HAS_ADD_LOADED = 'onboardingAdd/hasAddLoaded'
export const UPD_ADD_MEMO_CHAR_COUNT = 'onboardingAdd/updateMemoCharCount'
export const ADD_RECORD = 'onboardingAdd/addRecord'
export const ADD_PARTICIPANTS = 'onboardingAdd/addParticipants'
export const SET_HOLIDAY_DATES = 'onboardingAdd/setHolidayDates'
export const SET_ADD_EMAIL_TEMPLATE = 'onboardingAdd/setAddEmailTemplate'

// DETAIL TYPES
export const UPD_DETAIL_TITLE = 'onboardingDetail/changeTitle'
export const CHG_DETAIL_DATA = 'onboardingDetail/changeFieldData'
export const UPD_DETAIL_MODE = 'onboardingDetail/changeMode'
export const HAS_DETAIL_LOADED = 'onboardingDetail/hasDetailLoaded'
export const UPD_DETAIL_DATA = 'onboardingDetail/updateDetailData'
export const SET_DETAIL_CONFIRM_MODAL = 'onboardingDetail/setConfirmModel'
export const HIDE_DETAIL_CONFIRM_MODAL = 'onboardingDetail/hideConfirmModal'
export const SHOW_DETAIL_CONFIRM_MODAL = 'onboardingDetail/showConfirmModal'
export const SET_DETAIL_ALERT = 'onboardingDetail/setAlertModal'
export const HIDE_DETAIL_ALERT = 'onboardingDetail/hideAlert'
export const SET_DETAIL_DATA = 'onboardingDetail/setDetailData';
export const SET_PARTICIPANT_DATA = 'onboardingDetail/setParticipantData';
export const IS_DETAIL_LOADING = 'onboardingDetail/isLoading';
export const RESET_DETAIL_DATA = 'onboardingDetail/reset'
export const SET_EDITABLE = 'onboardingDetail/setEditable';
export const SET_DETAIL_EMAIL_TEMPLATE = 'onboardingDetail/setDetailEmailTemplate'